import { getGroupsStore } from '../GroupsStore';
import type UnifiedGroupDetails from 'owa-service/lib/contract/UnifiedGroupDetails';

export default function getGroupDetails(groupSmtpAddress: string): UnifiedGroupDetails {
    const groupStore = getGroupsStore();
    const group = groupStore.groups.get(groupSmtpAddress.toLowerCase());
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (10,5): Type 'UnifiedGroupDetails | null' is not assignable to type 'UnifiedGroupDetails'.
    // @ts-expect-error
    return group ? group.groupDetails : null;
}
